const listOfComplaintsStyle = () => ({
	moreWrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		cursor: 'pointer',
	},
	datePicker: {
		width: 'calc(50% - 4px)',
		display: 'inline-block',
		'&:first-child': {
			marginRight: 4,
		},
		'&:nth-child(2)': {
			marginLeft: 4,
		},
		'& .MuiFormControl-root': {
			marginBottom: 8,
		},
	},
});

export default listOfComplaintsStyle;
